import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { IconX } from "@tabler/icons-react";
import { connect } from "react-redux";
import { setAlert } from "../../redux/actions/alert";
import axios from "axios";
const SubscribeForm = ({ setAlert }) => {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");

  // Handle submit form
  const handleSubmit = (e) => {
    e.preventDefault();
    const fetchData = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/contact/newsletter/`,
          { email }
        );
        if (
          res.status === 201 &&
          res.data.message === "You have successfully subscribed."
        ) {
          setAlert(res.data.message, "success");
          setEmail("");
          setShowModal(false);
        }
      } catch (err) {
        if (
          err.response &&
          err.response.status === 400 &&
          err.response.data.error === "You have already subscribed."
        ) {
          setAlert(err.response.data.error, "error");
          setEmail("");
          setShowModal(false);
        } else {
          setAlert("An error occurred. Please try again later.", "error");
        }
      }
    };
    fetchData();
  };

  return (
    <div className="relative">
      {/* BUTTON TO OPEN MODAL */}
      {!showModal && (
        <button
          className="rounded-full bg-white text-[#40493A] font-bold text-sm px-6 py-2 h-8 leading-none shadow"
          onClick={() => setShowModal(true)}
        >
          STAY CONNECTED
        </button>
      )}

      <AnimatePresence>
        {showModal && (
          // BACKDROP
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center px-5 sm:px-0 rounded-md"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Semi-transparent overlay to close modal on click */}
            <div
              className="absolute inset-0 bg-black bg-opacity-50"
              onClick={() => setShowModal(false)}
            />

            {/* MODAL CONTENT CONTAINER */}
            <motion.div
              className="relative z-10 w-full max-w-2xl mx-auto rounded-md shadow-lg bg-white "
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >
              {/* CLOSE BUTTON */}
              <button
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                onClick={() => setShowModal(false)}
              >
                <IconX size={24} strokeWidth={2} />
              </button>

              {/* YOUR SUBSCRIPTION SECTION */}
              <section className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:px-8">
                <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.green.100),white)] opacity-20"></div>
                <div className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-green-600/10 ring-1 ring-green-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center"></div>

                <div className="mx-auto max-w-2xl lg:max-w-4xl text-center">
                  <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    Subscribe to our Newsletter
                  </h2>
                  <p className="mt-4 text-lg leading-6 text-gray-600">
                    Get the latest news, updates, and exclusive offers delivered
                    straight to your inbox.
                  </p>

                  {/* FORM */}
                  <form
                    className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
                    onSubmit={handleSubmit}
                  >
                    <input
                      type="email"
                      placeholder="Enter your email"
                      className="w-full sm:w-auto min-w-[300px] rounded-md border border-gray-300 px-4 py-3 text-base placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoComplete="off"
                    />
                    <div className="flex  sm:flex-row items-center justify-center gap-4 mt-4 sm:mt-0">
                      <button
                        type="submit"
                        className="rounded-md bg-green-600 px-8 py-3 text-base font-semibold text-white shadow hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                      >
                        Subscribe
                      </button>
                      <button
                        type="button"
                        className="rounded-md bg-gray-600 px-8 py-3 text-base font-semibold text-white shadow hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </section>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { setAlert })(SubscribeForm);
